export enum SignInFlowType {
  LOGIN = "login",
  SIGN_UP = "sign_up",
}

export enum SuccessfulLoginType {
  EMAIL = "email",
  APPLE = "apple",
  GOOGLE = "google",
}

export const SUCCESSFUL_LOGIN_TYPE = "successfulLoginType";
